import Vue from 'vue';
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'
import { Project } from '@/models/Project'
import ProjectService from '@/services/ProjectService'
const projectService = new ProjectService()

export interface ProjectState {
  projects: Array<Project>;
  activeProjectId: string;
  tags: Array<string>;
  categories: Array<string>;
}

const state: ProjectState = {
  projects: [],
  activeProjectId: '',
  tags: [],
  categories: [],
}

const mutations: MutationTree<ProjectState> = {
  SET_PROJECTS(state: ProjectState, projects: Array<Project>) {
    state.projects = projects
  },
  SET_ACTIVE_PROJECT(state: ProjectState, projectId: string) {
    state.activeProjectId = projectId
  },
  SET_TAGS(state: ProjectState, data: Array<string>) {
    state.tags = data
  },
  SET_CATEGORIES(state: ProjectState, data: Array<string>) {
    state.categories = data
  },
  ADD_PROJECT(state: ProjectState, project: Project) {
    const index = state.projects.findIndex((obj: Project) => obj.id === project.id)
    if (index < 0) {
      state.projects.push(project)
    }
  },
  UPDATE_PROJECT(state: ProjectState, project: Project) {
    const index = state.projects.findIndex((obj: Project) => obj.id === project.id)
    if (index > -1) {
      Vue.set(state.projects, index, project)
    }
  },
  REMOVE_PROJECT(state: ProjectState, project: Project) {
    const index = state.projects.findIndex((obj: Project) => obj.id === project.id)
    if (index > -1) {
      Vue.delete(state.projects, index)
    }
  },
}

const actions: ActionTree<ProjectState, any> = {
  setActiveProject({ commit }, projectId: string) {
    if (projectId && projectId != 'null') {
      localStorage.setItem('activeProjectId', projectId)
      commit('SET_ACTIVE_PROJECT', projectId)
    }
  },
  async fetchProjects({ commit, dispatch }, userId: string) {
    const projects = await projectService.fetchUserProjects(userId)
    commit('SET_PROJECTS', projects)
    if (projects && projects.length) {
      const storageProjectId: any = localStorage.getItem('activeProjectId');
      const lastProjectId = (storageProjectId && typeof storageProjectId !== 'undefined' && storageProjectId != 'undefined') ? storageProjectId : projects[0].id;

      dispatch('setActiveProject', lastProjectId)
      dispatch('fetchProjectData', lastProjectId)
    }

  },
  async fetchProjectData({ commit }, projectId: string) {
    if (!projectId) return;
    const data = await projectService.fetchProjectData(projectId)
    if (data) {
      data.forEach((item: any) => {
        if (item.type === 'tags') {
          commit('SET_TAGS', item.data)
        }
        else if (item.type === 'categories') {
          commit('SET_CATEGORIES', item.data)
        }
      })
    }
  },
  async createProject({ commit }, payload: any) {
    const project = payload.project;
    const user = payload.user;
    await projectService.createProject(project)
      .then(async (result: any) => {
        project.id = result
        commit('ADD_PROJECT', project)
        await projectService.addProjectUser(project.id, user.id, user.firstName, user.lastName, user.email, 'ACTIVE', true)
      })
  },
  async updateProject({ commit }, item: Project) {
    await projectService.editProject(item)
      .then(() => {
        commit('UPDATE_PROJECT', item)
      })
  },
}

const getters: GetterTree<ProjectState, RootState> = {
  getProjects: (state: ProjectState) => {
    return state.projects
  },
  getActiveProject: (state: ProjectState) => {
    if (state.activeProjectId != '') {
      return state.projects.find((project: Project) => project.id === state.activeProjectId)
    }
  },
  getTags: (state: ProjectState) => {
    return state.tags
  },
  getCategories: (state: ProjectState) => {
    return state.categories
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
